

const HomePage = () => {

  return (
    <div className="min-h-screen bg-transparent text-white flex overflow-hidden  items-center justify-center">
      <div className='w-1/2  flex flex-col justify-center items-center text-center p-10 md:p-20'>
        <h2 className='text-6xl md:text-8xl font-bold tracking-tighter'>MAKING.</h2>
        <h2 className='text-6xl md:text-8xl font-bold tracking-tighter'>HEALTH.</h2>
        <h2 className='text-6xl md:text-8xl font-bold tracking-tighter mb-8'>COOL.</h2>
        <hr className="w-full border-white/90" />
        <p className='text-lg font-medium opacity-80 mt-4 mb-6 uppercase'>Fueled by Humans. <br />Powered by AI. <br />Driven by Community. </p>
        <button
            type="button"
            onClick={() => window.open('https://form.typeform.com/to/XgdATyko')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 disabled:bg-gray-500 disabled:cursor-not-allowed"
          >
            join wait list
          </button>
      </div>
     
    </div>
  );
};

export default HomePage;
